import * as Context from 'waypoints/src/context'
import * as Group from 'waypoints/src/group'
import * as Inview from 'waypoints/src/shortcuts/inview'
import * as Waypoint from 'waypoints/src/waypoint'

class WaypointAdapter {
  handlers: object
  constructor(readonly element) {
    this.handlers = {}
  }

  innerHeight(): number {
    const isWin = isWindow(this.element)

    return isWin ? this.element.innerHeight : this.element.clientHeight
  }

  innerWidth(): number {
    const isWin = isWindow(this.element)

    return isWin ? this.element.innerWidth : this.element.clientWidth
  }

  off(event, handler): void {
    function removeListeners(element, listeners, handler): void {
      for (let i = 0, end = listeners.length - 1; i < end; i++) {
        const listener = listeners[i]
        if (!handler || handler === listener) {
          element.removeEventListener(listener)
        }
      }
    }

    const eventParts = event.split('.')
    const eventType = eventParts[0]
    const namespace = eventParts[1]
    const element = this.element

    if (namespace && this.handlers[namespace] && eventType) {
      removeListeners(element, this.handlers[namespace][eventType], handler)
      this.handlers[namespace][eventType] = []
    } else if (eventType) {
      for (const ns in this.handlers) {
        removeListeners(element, this.handlers[ns][eventType] || [], handler)
        this.handlers[ns][eventType] = []
      }
    } else if (namespace && this.handlers[namespace]) {
      for (const type in this.handlers[namespace]) {
        removeListeners(element, this.handlers[namespace][type], handler)
      }
      this.handlers[namespace] = {}
    }
  }

  offset(): { top: number; left: number } | null {
    if (!this.element.ownerDocument) {
      return null
    }

    const documentElement = this.element.ownerDocument.documentElement
    const win = getWindow(this.element.ownerDocument)
    let rect = {
      top: 0,
      left: 0
    }

    if (this.element.getBoundingClientRect) {
      rect = this.element.getBoundingClientRect()
    }

    return {
      top: rect.top + win.pageYOffset - documentElement.clientTop,
      left: rect.left + win.pageXOffset - documentElement.clientLeft
    }
  }

  on(event, handler): void {
    const eventParts = event.split('.')
    const eventType = eventParts[0]
    const namespace = eventParts[1] || '__default'
    const nsHandlers = (this.handlers[namespace] =
      this.handlers[namespace] || {})
    const nsTypeList = (nsHandlers[eventType] = nsHandlers[eventType] || [])

    nsTypeList.push(handler)
    this.element.addEventListener(eventType, handler)
  }

  outerHeight(includeMargin: boolean): number {
    let height = this.innerHeight()
    let computedStyle

    if (includeMargin && !isWindow(this.element)) {
      computedStyle = window.getComputedStyle(this.element)
      height += parseInt(computedStyle.marginTop, 10)
      height += parseInt(computedStyle.marginBottom, 10)
    }

    return height
  }

  outerWidth(includeMargin): number {
    let width = this.innerWidth()
    let computedStyle

    if (includeMargin && !isWindow(this.element)) {
      computedStyle = window.getComputedStyle(this.element)
      width += parseInt(computedStyle.marginLeft, 10)
      width += parseInt(computedStyle.marginRight, 10)
    }

    return width
  }

  scrollLeft(): number {
    const win = getWindow(this.element)

    return win ? win.pageXOffset : this.element.scrollLeft
  }

  scrollTop(): number {
    const win = getWindow(this.element)

    return win ? win.pageYOffset : this.element.scrollTop
  }

  static extend(): object {
    /* eslint-disable-next-line */
    const args = Array.prototype.slice.call(arguments)

    function merge(target, obj): object {
      if (typeof target === 'object' && typeof obj === 'object') {
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            target[key] = obj[key]
          }
        }
      }

      return target
    }

    for (let i = 1, end = args.length; i < end; i++) {
      merge(args[0], args[i])
    }

    return args[0]
  }

  static inArray(element, array, i): boolean {
    return array == null ? -1 : array.indexOf(element, i)
  }

  static isEmptyObject(object): boolean {
    for (const _ in object) {
      return false
    }

    return true
  }
}

function isWindow(element): boolean {
  return element === element.window
}

function getWindow(element): Window {
  if (isWindow(element)) {
    return element
  }

  return element.defaultView
}

Waypoint.adapters.push({
  name: 'WaypointAdapter',
  Adapter: WaypointAdapter
})

/* eslint-disable */
Waypoint.Group = Group
Waypoint.Context = Context
Waypoint.Adapter = WaypointAdapter
Waypoint.Inview = Inview
/* eslint-enable */

export default Waypoint
